<template lang="html">
   <section class="search-page">
      <div class="container">
         <h2>Espace de sélection</h2>
         <div class="columns">
            <div class="column">
               <b-field label="Sélectionner les équipementiers">
                  <b-taginput v-model="tags" :data="filteredTags" ellipsis autocomplete :allow-new="false" field="brand" icon="magnify" placeholder="Exemple: BREMBO" @typing="getFilteredTags">
                  </b-taginput>
               </b-field>
            </div>
            <div class="column">
               <b-field label="Sélectionner une famille" style="text-align:center">
                  <b-select expanded rounded placeholder="Exemple: Plaquette de freins" v-model="selected_family">
                     <option v-for="option in families" :value="option.id" :key="option.id">
                        {{ option.name }} (Quantité: {{option.qty}})
                     </option>
                  </b-select>
               </b-field>
            </div>
         </div>
         <div>
            <button class="button is-primary" v-on:click="loadItems" slot="trigger">Rafraichir</button>
         </div>
         <div>
            <div style="text-align:left;display:inline-block;margin:20px auto;">
               <b-collapse class="card" style="width:100%" :open="false">
                  <div slot="trigger" class="panel-heading">
                     <strong>Filtrer l'export</strong>
                  </div>
                  <div class="card-content">
                     <div class="content">
                        <div class="columns" v-for="n,i in nbRow">
                           <!-- <div v-for="(count,key,index) in extradata" v-if="(index)%4 == i" class="column is-one-quarter"> -->
                           <!-- {{index}}  -->
                           <div v-for="(count,key,index) in extradata" v-if="index >= 4 * (i) && index < 4 * (i+1)" class="column">
                              <!-- {{index}} -->
                              <b-checkbox v-model="checkedFilters" :native-value="key"><b>{{key}}</b> ({{count}})</b-checkbox>
                           </div>
                        </div>
                     </div>
                  </div>
                  <footer class="card-footer">
                     <a v-on:click="SaveCurrentsettings" class="card-footer-item">Sauvegarder la recherche</a>
                  </footer>
               </b-collapse>
            </div>
         </div>
         <button class="button is-primary" v-on:click="exportToCSV" slot="trigger">Exporter en CSV/Excel</button>
         <button class="button is-primary" v-on:click="exportToGsheets" slot="trigger">Exporter vers Google Spreadsheets</button>
         <br/>
         <br/>
         <div>
            <p>Espace de recherche</p>
            <b-field label="Filtrer par référence">
               <b-input v-model="filterRef"></b-input>
            </b-field>
         </div>
         <br/>
         <div>
            <b-loading :active.sync="isLoading" :can-cancel="true"></b-loading>
            <!-- <b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="true"></b-loading> -->
            <div class="nodata" v-if="hasData">
               <b-icon icon="emoticon-sad" size="is-large" type="is-primary">
               </b-icon>
               <p>
                  Pas de données à afficher
               </p>
               <small>Veuillez sélectionner un équipementier et une famille</small>
            </div>
            <b-table v-else :data="filteredProductByRef" paginated per-page="30" hoverable :opened-detailed="defaultOpenedDetails" detailed detail-key="id">
               <template slot-scope="props">
                  <b-table-column field="id" label="ID" width="40" numeric>
                     {{ props.row.id }}
                  </b-table-column>
                  <b-table-column field="brand" label="Marque" sortable>
                     {{ props.row.brand }}
                  </b-table-column>
                  <b-table-column field="brand_ref" label="Référence equipementier" sortable>
                     {{ props.row.ref }}
                  </b-table-column>
               </template>
               <template slot="detail" slot-scope="props">
                  <article class="media">
                     <figure class="media-left">
                        <b-icon icon="information-outline" size="is-large" type="is-primary">
                        </b-icon>
                     </figure>
                     <div class="media-content">
                        <div class="content">
                           <p>
                              <strong>{{ props.row.brand }} </strong>
                              <small> - ref:  <i>{{ props.row.ref }}</i></small>
                              <br>
                              <i>{{props.row.genart}}</i>
                              <br>
                           <p><b>Nomenclature</b>: {{ props.row.nomenclature }}</p>
                           <p><b>Status/Disponiblité</b>: {{ props.row.disponibilite }}</p>
                           <p><b>EAN</b>: {{ props.row.ean || "N.C"}}</p>
                           <div v-if="props.row.data">
                              <b-table :data="props.row.data" hoverable detail-key="datas">
                                 <template slot-scope="datas">
                                    <b-table-column field="Information" label="Information" sortable>
                                       {{ datas.row.nom_carac }}
                                    </b-table-column>
                                    <b-table-column field="Valeur" label="Valeur" sortable>
                                       {{ datas.row.value }}
                                    </b-table-column>
                                    <b-table-column field="Description" label="Description" sortable>
                                       {{ datas.row.description }}
                                    </b-table-column>
                                 </template>
                              </b-table>
                           </div>
                           <div class="nodata" style="text-align:center" v-else>
                              <b-icon
                                 icon="emoticon-sad"
                                 size="is-large"
                                 type="is-primary">
                              </b-icon>
                              <p>
                                 Pas de données à afficher pour cette pièce
                              </p>
                           </div>
                        </div>
                     </div>
                  </article>
               </template>
            </b-table>
         </div>
      </div>
   </section>
</template>
<script lang="js">
  export default {
    name: 'search-page',
    props: [],
    mounted() {
      if (this.$route.query.restore) {
        var code = this.$route.query.restore;
        this.axios.get(process.env.VUE_APP_API_URL + 'api/search/' + code, {
          responseType: 'json',
          headers: {
            'Authorization': sessionStorage.getItem('profile_token')
          }
        }).then((response) => {
          this.selected_brands = response.data.data[0].brands;
          this.selected_brands.forEach((e) => {
            this.tags.push({
              id: e
            })
          });
          this.selected_family = response.data.data[0].family;
          this.retrieveBrands(() => {
  
          });
          this.saved_filters = response.data.data[0].labels;
          var vueAppTmp = this;
  
          this.loadItems(() => {
            this.$router.push('/search');
          });
        });
      } else {
        this.init();
        this.retrieveBrands();
        this.isLoadingFromCode = false;
  
      }
    },
    data() {
      return {
        tags: [],
        filteredTags: ["test", "brembo", "ferrodo"],
        isLoading: false,
        saved_filters: [],
        families: [],
        brands: ["test", "brembo", "ferrodo"],
        isLoadingFromCode: true,
        family: {
          "name": '',
        },
        brand: {
          "name": '',
        },
        selected_family: 0,
        selected_brand: null,
        selected_brands: [],
        products: [],
        checkedFilters: [],
        extradata: [],
        defaultOpenedDetails: [1],
        filterRef: '',
        hasToProcess: false,
  
      }
    },
    watch: {
      tags: "onTagsChanged",
      "brand.name": 'onBrandChanged',
      selected_brand: 'resetAll',
      selected_family: 'onsettingsChanged',
    },
    methods: {
      extractId(array) {
        var result = []
        array.forEach((e) => {
          result.push(e.id);
        });
        // return result.length > 0 ? result : null;
        return result;
      },
      onTagsChanged() {
        this.retrieveFamilies(this.extractId(this.tags));
      },
      getFilteredTags(text) {
        this.filteredTags = this.brands.filter((option) => {
          return option.brand
            .toString()
            .toLowerCase()
            .indexOf(text.toLowerCase()) >= 0
        })
      },
      onBrandChanged() {
        if (this.brand.name == "") {
          this.resetAll()
        }
      },
      resetAll() {
        if (this.selected_brand != null) {
          this.families = [];
        } else {
          this.init();
        }
        this.family = {
          "name": '',
        };
        if (!this.isLoadingFromCode) {
          this.selected_family = null;
          this.selected_family = null;
          this.saved_filters = null;
  
        }
        this.products = [];
        this.checkedFilters = [];
        this.extradata = [];
        this.filterRef = '';
      },
      SaveCurrentsettings() {
        if (this.selected_family) {
  
          var url = process.env.VUE_APP_API_URL + 'api/search';
  
          this.axios.post(url, {
              "brand": this.extractId(this.tags),
              "family": this.selected_family,
              "labels": this.checkedFilters,
  
            }, {
              responseType: 'json',
              headers: {
                'Authorization': sessionStorage.getItem('profile_token')
              },
            })
            .then((response) => {
              this.$snackbar.open({
                position: 'is-top-right',
                message: 'Les paramètres ont bien été enregistrés',
                type: 'is-success',
              })
            });
        } else {
          this.$snackbar.open({
            position: 'is-top-right',
            message: 'Veuillez sélectionner un équipementier et une famille',
            type: 'is-warning',
          })
        }
  
      },
      updatedBrand(option, callback) {
        if (option == null) {
          this.selected_brand = null;
          this.resetAll();
          return
        };
        this.selected_brand = option.id;
        var url = process.env.VUE_APP_API_URL + 'api/brand/' + option.id + '/family';
  
        this.axios.get(url, {
            responseType: 'json',
            headers: {
              'Authorization': sessionStorage.getItem('profile_token')
            },
          })
          .then((response) => {
            this.families = response.data.data;
            this.families= this.families.sort(
             (a, b) => {
                if (a.name < b.name) return -1;
                if (a.name > b.name) return 1;
                return 0;
              });
            if (callback && typeof callback === "function") {
              callback();
            }
          });
      },
      loadItems(callback) {
        if (this.selected_family) {
          var url = process.env.VUE_APP_API_URL + 'api/article';
          this.requestProducts(url, callback);
        } else {
  
        }
  
      },
      requestProducts(url, callback) {
  
        this.isLoading = true;
        if (this.selected_family) {
          var filters = this.checkedFilters;
          this.axios.get(url, {
              params: {
                brand: this.extractId(this.tags).join(","),
                family: this.selected_family
              },
              responseType: 'json',
              headers: {
                'Authorization': sessionStorage.getItem('profile_token')
              },
            })
            .then((response) => {
              this.products = response.data.data;
              this.extradata = response.data.extradata;
              this.checkedFilters = this.getExtradataNames();
              this.isLoading = false;
              if (callback  && typeof callback === "function") {
                callback();
              }
            }).catch((error) => {
              alert("une erreur est survenue");
              console.log(error);
              this.isLoading = false;
            });
        }
      },
      getExtradataNames() {
        var array = [];
        Object.keys(this.extradata).forEach((e) => {
          if (this.saved_filters == null || (this.saved_filters != null && this.saved_filters.indexOf(e) == -1)) {
            // alert("saved search");
            array.push(e)
  
          }
        });
        return array;
      },
      onsettingsChanged() {
        if ((this.selected_family == null && this.selected_brand == null)) {
          this.products = [];
        }
        this.loadItems()
      },
      exportToCSV() {
        this.$snackbar.open({
          position: 'is-top-right',
          message: 'Le téléchargement devrait commencer brièvement',
          type: 'is-info',
        })
        if (this.selected_family) {
          var url = process.env.VUE_APP_API_URL + 'api/article';
          this.axios.post(url, {
              filters: this.checkedFilters,
            }, {
              params: {
                brand: this.extractId(this.tags).join(","),
                family: this.selected_family,
                type: "csv"
              },
              responseType: 'blob',
              headers: {
                'Authorization': sessionStorage.getItem('profile_token')
              },
            })
            .then((response) => {
              this.$snackbar.open({
                position: 'is-top-right',
                message: 'Le fichier est prêt',
                type: 'is-success',
              })
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', 'export.csv'); //or any other extension
              document.body.appendChild(link);
              link.click();
            });
        }
      },
      exportToGsheets() {
        this.$snackbar.open({
          message: 'Traitement en cours',
          actionText: 'OK',
          duration: 15000,
          type: 'is-success',
          position: 'is-top-right',
        });
          var url = process.env.VUE_APP_API_URL + 'api/article';
          this.axios.post(url, {
              filters: this.checkedFilters,
            }, {
              params: {
                brand: this.extractId(this.tags).join(","),
                family: this.selected_family,
                type: "gsheet"
              },
              headers: {
                'Authorization': sessionStorage.getItem('profile_token')
              },
            })
            .then((response) => {
              window.open("https://docs.google.com/spreadsheets/d/" + response.data.data.gsheet);
            });
      },
      retrieveFamilies(brand) {
        if (brand.length == 0) {
          this.selected_family = null;
        }
        this.axios.get(process.env.VUE_APP_API_URL + 'api/family', {
            params: {
              brand: brand.join(',')
            },
            headers: {
              'Authorization': sessionStorage.getItem('profile_token')
            },
            responseType: 'json',
          })
          .then((response) => {
           this.families = response.data.data;
            this.families= this.families.sort(
              (a, b) => {
                if (a.name < b.name) return -1;
                if (a.name > b.name) return 1;
                return 0;
              }
            )
          });
      },
      init() {
        this.retrieveBrands();
        this.retrieveAllFamilies();
      },
      retrieveBrands(callback) {
        this.axios.get(process.env.VUE_APP_API_URL + 'api/brand', {
            responseType: 'json',
            headers: {
              'Authorization': sessionStorage.getItem('profile_token')
            },
          })
          .then((response) => {
            var brandsReformatted = response.data.data
            this.brands = response.data.data;
            this.filteredTags = response.data.data;
            if (this.selected_brands != null) {
              this.tags = [];
              this.brands.forEach(element => {
  
                if (this.selected_brands.includes(element.id)) {
                  this.tags.push(element);
                  // this.brand.name = element.brand;
                  // this.brand.id = element.id;
                }
              });
              // this.brands.forEach(element => {
              //   if (element.id == this.selected_brand) {
              //     this.brand.name = element.name;
              //   }
              // });
  
            }
            if (callback) {
              callback();
            }
          });
      },
      retrieveAllFamilies() {
        this.axios.get(process.env.VUE_APP_API_URL + 'api/family', {
            responseType: 'json',
            headers: {
              'Authorization': sessionStorage.getItem('profile_token')
            },
          })
          .then((response) => {
            this.families = response.data.data;
            this.families= this.families.sort(
              (a, b) => {
                if (a.name < b.name) return -1;
                if (a.name > b.name) return 1;
                return 0;
              }
            )
          });
      },
  
    },
    computed: {
      filteredFamilyArray() {
        return this.families.filter((option) => {
          return option.name
            .toLowerCase()
            .indexOf(this.family.name.toLowerCase()) >= 0;
        });
      },
      filteredProductByRef() {
        if (this.filterRef) {
          return this.products.filter((option) => {
            return option.ref
              .toLowerCase().replace(/ /g, '')
              .indexOf(this.filterRef.replace(/ /g, '').toLowerCase()) >= 0;
          });
        } else {
          return this.products;
        }
      },
      filteredBrandsArray() {
        return this.brands.filter((option) => {
          if (this.brand.name) {
            return option.brand
              .toLowerCase()
              .indexOf(this.brand.name.toLowerCase()) >= 0;
          } else {
            return option.id == (this.brand.id);
          }
        });
      },
      hasData() {
        return this.products.length == 0;
      },
      nbRow() {
        return Math.ceil(this.getExtradataNames().length / 4);
      },
      extradataLenth() {
        return this.checkedFilters.length;
      }
    }
  };
</script>

<style scoped lang="scss">
.search-page {
}

h2 {
  margin-bottom: 30px;
  font-weight: bold;
}

.nodata {
  padding: 30px;
  background-color: white;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/CommonPage.vue